/** @file A document table's entries in canonical order: by entity name, code-unit (ASCII) order (R12-01). */

/** -1, 0 or 1 by UTF-16 code units (names are ASCII, §5.1), never by locale. */
const byCodeUnits = (a: string, b: string): number => (a < b ? -1 : a > b ? 1 : 0);

/**
 * `Object.entries(table)` sorted by entity name in code-unit order (names are unique per kind; the id breaks a tie in
 * a table that is not). A document's key insertion order carries no meaning (R12-01): an undo re-adds a deleted key
 * at the end, so every consumer that orders animations, attachments, images, skins, events, sockets, references or
 * constraints takes this order, and compiling a document never depends on its edit history. A fresh array per call.
 */
export function entriesByName<T extends { name: string }>(table: Readonly<Record<string, T>>): [string, T][] {
  return Object.entries(table).sort(([ia, a], [ib, b]) => byCodeUnits(a.name, b.name) || byCodeUnits(ia, ib));
}
